import { BuildAction } from '@cgs/shared';
import { IWinLinesAction } from './i_win_lines_action';
import { Line, ReelWinPosition } from '@cgs/data-access';
import { Container, EmptyAction, IntervalAction } from '@cgs/wge';
import { AllWinLinesAction } from './all_win_lines_action';

export class SpecialWinLinesAction extends BuildAction implements IWinLinesAction {
  private _winPositions: ReelWinPosition[];
  private _container: Container;
  private _winLines: Line[];

  constructor(container: Container, winLines: Line[], winPositions: ReelWinPosition[]) {
    super();
    this._container = container;
    this._winLines = winLines;
    this._winPositions = winPositions;
  }

  public get winLines(): Line[] {
    return this._winLines;
  }

  buildAction(): IntervalAction {
    if (this._winLines.length === 0) {
      return new EmptyAction();
    }

    this._winLines = this._winPositions.map((item) => {
      const line = new Line();
      line.positions = item.positions;
      return line;
    });
    return new AllWinLinesAction(this._container, this._winLines);
  }
}
